<template>
  <div></div>
</template>

<script>
export default {
  data() {
    return {
      problems: {},
      locked: false,
      redirected: false,
      allowedWithQr: ['message', 'carousel', 'media', 'attachment', 'otn'],
      phoneNumberRegex: /^\+((?:9[679]|8[035789]|6[789]|5[90]|42|3[578]|2[1-689])|9[0-58]|8[1246]|6[0-6]|5[1-8]|4[013-9]|3[0-469]|2[70]|7|1)(?:\W*\d){0,13}\d$/g
    }
  },
  props: {
    steps: Array,
    blockUuid: String
  },
  methods: {
    buttonsValidate(buttons, set) {
      for (let btn of buttons) {
        if (!btn.text[this.$store.state.flowEditorLocale]) set.add(this.$t('view.flow.editor.validator.emptyBtnTitle'))
        if (btn.action === 'redirect') {
          if (!btn.data.target || !this.$store.getters.flowBlock(btn.data.target)) set.add(this.$t('view.flow.editor.validator.emptyBtnTarget'))
        } else if (btn.action === 'url' || btn.action === 'account_link') {
          if (!btn.data.url) set.add(this.$t('view.flow.editor.validator.emptyBtnUrl'))
        } else if (btn.action === 'postback') {
          if (!btn.data.payload) set.add(this.$t('view.flow.editor.validator.emptyBtnPayload'))
        } else if (btn.action === 'phone_number') {
          if (!btn.data.phone_number) set.add(this.$t('view.flow.editor.validator.emptyBtnPhone'))
          else if (!btn.data.phone_number.match(this.phoneNumberRegex)) set.add(this.$t('view.flow.editor.validator.incorrectBtnPhone'))
        }
      }
    },

    validateStep(step, prevStep, insideBlock = false) {
      let set = new Set()
      if (this.redirected && !insideBlock) set.add(this.$t('view.flow.editor.validator.redirected'))
      switch (step.action) {
        case 'message':
          if (!step.message.text[this.$store.state.flowEditorLocale]) set.add(this.$t('view.flow.editor.validator.messageEmpty'))
          this.buttonsValidate(step.message.buttons, set)
          break

        case 'qr':
          if (step.replies.map(r => r.data.target).indexOf(null) === -1) this.redirected = true
          for (let reply of step.replies) {
            if (!reply.text[this.$store.state.flowEditorLocale]) set.add(this.$t('view.flow.editor.validator.emptyReplyTitle'))
            if (insideBlock && !reply.data.target) set.add(this.$t('view.flow.editor.validator.noQrPauseInBlocks'))
          }
          if (step.saveToUserData && !step.userDataName) set.add(this.$t('view.flow.editor.validator.emptyDataName'))
          if (!prevStep || this.allowedWithQr.indexOf(prevStep.action) === -1) set.add(this.$t('view.flow.editor.validator.qrNotAfterMessage'))
          break

        case 'redirect':
          if (!step.target) this.problems[step.uuid] = set.add(this.$t('view.flow.editor.validator.emptyTarget'))
          if (!insideBlock) this.redirected = true
          break

        case 'group':
          if (!step.groupUuid) this.problems[step.uuid] = set.add(this.$t('view.flow.editor.validator.groupUuidRequired'))
          break

        case 'data':
          if (!step.data.name) this.problems[step.uuid] = set.add(this.$t('view.flow.editor.validator.dataNameRequired'))
          break

        case 'attachment':
          if (!step.attachmentUuid) this.problems[step.uuid] = set.add(this.$t('view.flow.editor.validator.attachmentUuidRequired'))
          if (step.attachmentUuid && !this.$store.state.attachments[step.attachmentUuid].attachment_id) this.problems[step.uuid] = set.add(this.$t('view.flow.editor.validator.attachmentWithoutId'))
          break

        case 'carousel':
          let ci = 1
          for (const card of step.cards) {
            let titleEmpty = false
            let subtitleEmpty = false

            for (const loc in card.title) {
              if (!card.title[loc].length) titleEmpty = true
            }

            for (const loc in card.subtitle) {
              if (!card.subtitle[loc].length) subtitleEmpty = true
            }

            if (titleEmpty || (subtitleEmpty && !card.image_url.length && !card.buttons.length)) set.add(this.$t('view.flow.editor.validator.cardInsufficient') + ' (' + ci + ')')
            this.buttonsValidate(card.buttons, set)
          }
          break

        case 'media':
          if (!step.payload) set.add(this.$t('view.flow.editor.validator.mediaNoPayload'))
          this.buttonsValidate(step.buttons, set)
          break

        case 'input':
          if (insideBlock) set.add(this.$t('view.flow.editor.validator.userInputInConditional'))
          if (!step.name || !step.incorrectInputMessage.text || !step.incorrectInputMessage.cancelButton || !step.incorrectInputMessage.cancelTarget || !this.$store.getters.flowBlock(step.incorrectInputMessage.cancelTarget)) {
            set.add(this.$t('view.flow.editor.validator.userInputRequiredFields'))
          }
          break

        case 'if':
          if (!step.condition) set.add(this.$t('view.flow.editor.validator.noCondition'))
          let stepsRedirect = false
          let elseStepsRedirect = false
          for (let i = 0; i < step.steps.length; i++) {
            this.validateStep(step.steps[i], step.steps[i - 1], true)
            if (step.steps[i].action === 'redirect') stepsRedirect = true
          }

          for (let i = 0; i < step.elseSteps.length; i++) {
            this.validateStep(step.elseSteps[i], step.elseSteps[i - 1], true)
            if (step.elseSteps[i].action === 'redirect') elseStepsRedirect = true
          }

          if (stepsRedirect && elseStepsRedirect) this.redirected = true
          break

        case 'otn':
          if (!step.name || !step.content || !step.confirmationBlock) set.add(this.$t('view.flow.editor.validator.otnParams'))
          if (/:/g.test(step.name)) set.add(this.$t('view.flow.editor.validator.otnNameContainsColon'))
          if (!/^[\w\s]*$/g.test(step.name)) set.add(this.$t('view.flow.editor.validator.otnNameRegex'))
          break

        case 'delay':
          if (!step.time || !step.timeUnit || !step.block) set.add(this.$t('view.flow.editor.validator.delayParams'))
          if (step.timeUnit === 'h' && step.time > 24) set.add(this.$t('view.flow.editor.validator.maxTime'))
          if (step.timeUnit === 'm' && step.time > 60) set.add(this.$t('view.flow.editor.validator.useHours'))
          break

        case 'switch':
          if (!step.expression) set.add(this.$t('view.flow.editor.validator.switchNoExpression'))
          if (!step.cases.length) set.add(this.$t('view.flow.editor.validator.switchNoCases'))
          for (const c of step.cases) {
            if (!c.steps.length) set.add(this.$t('view.flow.editor.validator.switchNoCaseSteps'))
            if (!c.case) set.add(this.$t('view.flow.editor.validator.switchNoCase'))
            for (let i = 0; i < c.steps.length; i++) {
              this.validateStep(c.steps[i], c.steps[i - 1], true)
            }
          }
          for (let i = 0; i < step.defaultSteps.length; i++) {
            this.validateStep(step.defaultSteps[i], step.defaultSteps[i - 1], true)
          }
          break;

        case 'random':
          if (step.blocks.length < 2) set.add(this.$t('view.flow.editor.validator.randomizerMin2Elements'))
          for (let i = 0; i < step.blocks.length; i++) {
            this.validateStep(step.blocks[i], step.blocks[i - 1], true)
          }
          break

        case 'goto':
          if (!step.label) set.add(this.$t('view.flow.editor.validator.gotoNoLabel'))
          break

        case 'gotoLabel':
          if (!step.label) set.add(this.$t('view.flow.editor.validator.gotoNoLabel'))
          if (insideBlock) set.add(this.$t('view.flow.editor.validator.gotoLabelInside'))
          break

        case 'blockInsert':
          if (!step.block) set.add(this.$t('view.flow.editor.validator.blockInsertNoBlock'))
          if (step.block === this.blockUuid) set.add(this.$t('view.flow.editor.validator.blockInsertSelf'))
          break

        case 'handover':
          if(step.type === 'pass') {
            if (!step.appId) set.add(this.$t('view.flow.editor.validator.handoverAppIdRequired'))
            else if (/\D/.test(step.appId)) set.add(this.$t('view.flow.editor.validator.handoverAppIdPattern'))
          }
      }
      this.problems[step.uuid] = Array.from(set)
    }
  },
  watch: {
    steps: {
      deep: true,
      handler: async function (steps) {
        if (this.locked) return
        await this.delayMs(300) // Await for multiple incoming events :(
        for (let i in steps) {
          this.validateStep(steps[i], steps[i - 1])
        }
        this.locked = true
        this.$emit('check', this.problems)
        this.problems = {}
        this.redirected = false
        await this.delayMs(100)
        this.locked = false
      }
    }
  }
}
</script>

<style>
</style>
